(()=>{
  'use strict';
  if(window.DoviarDailyCountdown){window.DoviarDailyCountdown.refresh();return;}
  const key='doviar_daily_reset_v1',day=24*60*60*1000;
  let deadline=null,interval=null;
  const valid=(value,now)=>Number.isSafeInteger(value)&&value>now&&value<=now+day;
  const parse=value=>typeof value==='string'&&/^\d+$/.test(value)?Number(value):null;
  const cookie=()=>{try{const entry=document.cookie.split(';').map(value=>value.trim()).find(value=>value.startsWith(key+'='));return entry?parse(entry.slice(key.length+1)):null;}catch{return null;}};
  const stored=()=>{try{return parse(window.localStorage.getItem(key));}catch{return null;}};
  const persist=(value,now)=>{
    try{
      document.cookie=key+'='+value+'; Max-Age='+Math.ceil((value-now)/1000)+'; Expires='+new Date(value).toUTCString()+'; Path=/; SameSite=Lax; Secure';
      if(cookie()===value){try{window.localStorage.removeItem(key);}catch{}return;}
    }catch{}
    try{window.localStorage.setItem(key,String(value));}catch{}
  };
  const restore=now=>{
    const fromCookie=cookie();if(valid(fromCookie,now))return fromCookie;
    const fallback=stored(),value=valid(fallback,now)?fallback:valid(deadline,now)?deadline:now+day;
    persist(value,now);return value;
  };
  const stop=()=>{if(interval!==null){clearInterval(interval);interval=null;}};
  const refresh=()=>{
    const blocks=document.querySelectorAll('[data-daily-countdown]');if(!blocks.length){stop();return;}
    const now=Date.now();if(!valid(deadline,now))deadline=restore(now);
    const remaining=Math.ceil((deadline-now)/1000),values=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60];
    blocks.forEach(block=>{
      const fields=['hours','minutes','seconds'].map(part=>block.querySelector('[data-countdown-'+part+']'));
      if(fields.some(field=>!field))return;
      fields.forEach((field,index)=>{field.textContent=String(values[index]).padStart(2,'0');});block.hidden=false;
    });
  };
  const activate=()=>{stop();if(!document.querySelectorAll('[data-daily-countdown]').length)return;deadline=restore(Date.now());refresh();if(!document.hidden)interval=setInterval(refresh,1000);};
  window.DoviarDailyCountdown={refresh:activate};
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else activate();});
  document.addEventListener('shopify:section:load',activate);
  document.addEventListener('shopify:section:unload',activate);
  activate();
})();
